module.exports = __webpack_public_path__ + "img/plans.53fed510.svg";